import React from 'react';
import {
  StyleSheet,
  Text,
  View,
  Pressable,
  Dimensions,
  StyleProp,
  ViewStyle,
  TextStyle,
} from 'react-native';
import Svg, { Defs, LinearGradient as SvgLinearGradient, Stop, Polygon } from 'react-native-svg';
import { applyTransparency } from '../../constants/colors';
import { MB_Modal } from '../../mightyByteLibraries/MB_Modal/MB_Modal';
import { CloseIcon } from '../../resources/svgComponents/CloseIcon';

interface IPopupProps {
  title: string;
  visible: boolean;
  setVisible: (value: boolean) => void;
  height?: number | string;
  children?: React.ReactNode;
  hasHeader?: boolean;
  closeOnBackdropPress?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  headerTextStyle?: StyleProp<TextStyle>;
  hideCloseButton?: boolean;
  headerComponent?: React.ReactNode;
  hexagonWidth?: number; // 🔑 new
  hexagonHeight?: number; // 🔑 new
  hexagonColor?: string[];
  icon?: React.ReactNode;
  modalStyle?: StyleProp<ViewStyle>;
}

const PopupV2 = ({
  title,
  visible,
  setVisible,
  children,
  height,
  hasHeader = true,
  closeOnBackdropPress = true,
  containerStyle,
  headerTextStyle,
  hideCloseButton,
  headerComponent,
  hexagonWidth = 346, // default 346
  hexagonHeight = 62, // default 62
  hexagonColor = ['#FF9252', '#FF3F15'],
  modalStyle,
  icon,
}: IPopupProps) => {
  return (
    <MB_Modal
      hideCloseButton
      isVisible={visible}
      backdropOpacity={0.2}
      backdropColor="#02010161"
      backdropBlurIntensity={0}
      animationIn="fadeIn"
      animationOut="fadeOut"
      onBackdropPress={() => (closeOnBackdropPress ? setVisible(false) : null)}
      modalStyle={modalStyle}
    >
      <View
        style={[
          styles.container,
          {
            width: Dimensions.get('screen').width - 32,
            height: height || 350,
          },
          containerStyle,
        ]}
      >
        {hasHeader && (
          <>
            {hideCloseButton ? null : (
              <Pressable style={{ zIndex: 10 }} onPress={() => setVisible(false)}>
                <CloseIcon containerstyle={styles.closeIcon} />
              </Pressable>
            )}
            {headerComponent ? (
              headerComponent
            ) : (
              <View style={styles.absoluteContainer}>
                {/* Hexagon scaled to 346x62 */}
                <View style={styles.hexagonWrapper}>
                  <Svg height={hexagonHeight} width={hexagonWidth} viewBox="0 0 346 62">
                    <Defs>
                      <SvgLinearGradient id="grad" x1="0" y1="0" x2="1" y2="1">
                        <Stop offset="0" stopColor={hexagonColor[0]} />
                        <Stop offset="1" stopColor={hexagonColor[1]} />
                      </SvgLinearGradient>
                    </Defs>
                    <Polygon
                      // Hexagon points normalized to 346x62
                      points="31,0 315,0 346,31 315,62 31,62 0,31"
                      fill="url(#grad)"
                      stroke={applyTransparency('#FFFFFF', 0.4)}
                      strokeWidth="3"
                    />
                  </Svg>

                  <Text
                    maxFontSizeMultiplier={1}
                    style={[
                      styles.title,
                      { width: hexagonWidth * 0.85 }, // fit text inside
                      headerTextStyle,
                    ]}
                    numberOfLines={1}
                  >
                    {icon} {icon ? ' ' : null} {title}
                  </Text>
                </View>
              </View>
            )}
          </>
        )}
        {children}
      </View>
    </MB_Modal>
  );
};

export { PopupV2 };

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    maxWidth: 545,
    backgroundColor: '#FFF5DD',
    borderRadius: 24,
    borderColor: '#FF9900',
    borderWidth: 3,
    maxHeight: '80%',
  },
  title: {
    color: 'white',
    fontFamily: 'Secular One',
    fontSize: 20,
    position: 'absolute',
    textAlign: 'center',
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 2,
  },
  absoluteContainer: {
    position: 'absolute',
    top: -27,
    left: 0,
    right: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  hexagonWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeIcon: { position: 'absolute', right: -8, top: -20, zIndex: 10 },
});
